import { Component } from '@angular/core';
import { ModalFeedbackType } from '@trato-logistica/trato-web-ui';
import { ModalFeedbackBaseComponent } from '../modal-feedback-base';

@Component({
  templateUrl: '../modal-feedback-base.html',
  styleUrls: ['./generic-modal-chapa.component.scss'],
  standalone: false,
})
export class GenericModalChapaComponent extends ModalFeedbackBaseComponent {
  get type(): ModalFeedbackType {
    return this.data?.icon;
  }

  get bodyText(): string {
    return this.data?.message;
  }

  get confirmText(): string {
    return this.data?.confirmText;
  }

  get cancelText(): string {
    return this.data?.cancelText;
  }
}
